export default __webpack_public_path__ + "static/media/G0750.34I-27930_-17362_0.1666265460000.4d9ce631.jpg";